import { GlobalState } from '../../actions';

export const userSearchSelector = (state: GlobalState) => state.userSearch;

export const userSearchEntitySelector = (state: GlobalState) => userSearchSelector(state).searchResults;
export const userSearchStringSelector = (state: GlobalState) => userSearchSelector(state).searchString;
export const userSearchCountSelector = (state: GlobalState) => userSearchSelector(state).searchResultCount;